var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('alert',{attrs:{"header":_vm.getAlertHeaderText,"show-alert":_vm.getAlertShow},on:{"continue-action":function($event){return _vm.hideAlert()}}},[_vm._v(" "+_vm._s(_vm.getAlertText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }